module.exports = __webpack_public_path__ + "static/img/bilive.c0c7016f.jpg";